import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NotificationContext from "views/Components/Context.js";
import ArtifactStructureReview from "./ArtifactStructureReview";

export default function Slides(props) {
  const [slides, setSlides] = React.useState([]);
  const { showNotification } = React.useContext(NotificationContext);
  const { courseID, moduleID } = props;
  const [isInitialized, setIsInitialized] = useState(courseID && moduleID);
  const setSlidesForCard = () => {
    const card = props.slides;

    if (card) {
      const updatedSlides = card.map((slide) => {
        return {
          id: slide.resource_id,
          name: slide.resource_name,
          url: slide.resource_link,
          description: slide.resource_description,
          type: slide.resource_type,
        };
      });
      setSlides(updatedSlides);
    } else {
    }
  };

  // Call setFilesForCard whenever the id changes
  useEffect(() => {
    setSlidesForCard();
    setIsInitialized(true);
  }, []);

  // Ensure props are fully initialized before rendering ArtifactStructureReview
  const embedUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
    slides[0]?.url
  )}&wdHideToolbar=True`;
  return (
    <div>
      <Grid container spacing={3}>
        
        <Grid item xs={12} sm={12}>
          {isInitialized ? (
            <>
              <div
                style={{
                  width: "100%",
                  height: "700px",
                  border: "none",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <iframe
                  title="PPTX Viewer"
                  src={embedUrl}
                  style={{
                    display: "block",
                  }}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                />
              </div>
              <ArtifactStructureReview
                files={slides}
                courseID={courseID}
                moduleID={moduleID}
                courseDesignStep={11}
                showReplace={false}
              />
            </>
          ) : (
            <Typography variant="body1">Loading...</Typography>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
